import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import ScrollProgress from "./use-scroll-progress";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-scroll-progress"
    }}>{`use-scroll-progress`}</h1>
    <p>{`Hook Description`}</p>
    <Playground __position={0} __code={'<ScrollProgress />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ScrollProgress
    }} mdxType="Playground">
  <ScrollProgress mdxType="ScrollProgress" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { useScrollProgress } from "react-hooks-lab";

const ScrollProgress = () => {
  const scrollProgress = useScrollProgress();

  return (
    <>
      <div className="scroll" style={{ width: \`\${scrollProgress}%\` }}></div>
      <div>{scrollProgress}</div>
    </>
  );
};
export default ScrollProgress;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      